const einvoicing = {
  // ==================== E-INVOICING ====================
  'einvoicing.title': 'E-Invoicing',
  'einvoicing.subtitle': 'Digitally capture, verify and match incoming invoices with purchase orders',
  'einvoicing.inDevelopmentDesc': 'The E-Invoicing module will enable digital capture and processing of incoming invoices, automatic matching with purchase orders and goods receipts, and forwarding into the approval process.',

  // Navigation
  'einvoicing.navDashboard': 'Dashboard',
  'einvoicing.navInbox': 'Inbox',
  'einvoicing.navOutbound': 'Outbox',
  'einvoicing.navCoverage': 'Countries & Formats',

  // Dashboard
  'einvoicing.kpiNeedsAction': 'Needs action',
  'einvoicing.kpiValidationFailed': 'Validation failed',
  'einvoicing.kpiDueSoon': 'Due within 7 days',
  'einvoicing.kpiOutboundOpen': 'Outbox open',
  'einvoicing.dashVolume': 'Document volume (12 months)',
  'einvoicing.dashFunnel': 'Inbound status overview',
  'einvoicing.dashRegimes': 'Country coverage',
  'einvoicing.dashRecent': 'Recent activity',
  'einvoicing.dashEmpty': 'No documents yet.',
  'einvoicing.dashLoadError': 'Could not load dashboard',
  'einvoicing.funnelInProcess': 'In process',
  'einvoicing.funnelError': 'Errors / rejected',
  'einvoicing.funnelComplete': 'Complete',
  'einvoicing.inbound': 'Inbound',
  'einvoicing.outbound': 'Outbound',
  'einvoicing.loading': 'Loading …',

  // List
  'einvoicing.searchPlaceholder': 'Search number or partner …',
  'einvoicing.allStates': 'All states',
  'einvoicing.needsActionOnly': 'Needs action only',
  'einvoicing.uploadButton': 'Upload invoice',
  'einvoicing.listEmpty': 'No invoices found.',
  'einvoicing.listLoadError': 'Could not load list',
  'einvoicing.uploadOk': 'Invoice imported ({format})',
  'einvoicing.uploadError': 'Upload failed',
  'einvoicing.uploadValidationFailed': 'Imported with {n} validation errors — please review',
  'einvoicing.colNumber': 'Number',
  'einvoicing.colCounterparty': 'Partner',
  'einvoicing.colIssueDate': 'Invoice date',
  'einvoicing.colDueDate': 'Due',
  'einvoicing.colAmount': 'Amount',
  'einvoicing.colFormat': 'Format',
  'einvoicing.colStatus': 'Status',
  'einvoicing.colMatch': 'Match',
  'einvoicing.noNumber': '(no number)',

  // Business state (track 1)
  'einvoicing.state.received': 'Received',
  'einvoicing.state.validated': 'Validated',
  'einvoicing.state.validation_failed': 'Validation failed',
  'einvoicing.state.in_approval': 'In approval',
  'einvoicing.state.approved': 'Approved',
  'einvoicing.state.rejected': 'Rejected',
  'einvoicing.state.posted_to_sap': 'Posted to SAP',
  'einvoicing.state.archived': 'Archived',
  'einvoicing.state.draft': 'Draft',
  'einvoicing.state.generated': 'Generated',
  'einvoicing.state.sent': 'Sent',

  // Transport state (track 2)
  'einvoicing.transport.received': 'Received',
  'einvoicing.transport.delivered': 'Delivered',
  'einvoicing.transport.submitted': 'Submitted',
  'einvoicing.transport.upo_received': 'UPO received',
  'einvoicing.chip.business': 'Business status (workflow)',
  'einvoicing.chip.transport': 'Transport/authority status',

  // Match
  'einvoicing.match.matched': 'PR matched',
  'einvoicing.match.partial': 'Partial (review)',
  'einvoicing.match.no_match': 'No PR found',
  'einvoicing.match.unavailable': 'Matching unavailable',

  // Detail
  'einvoicing.seller': 'Seller',
  'einvoicing.buyer': 'Buyer',
  'einvoicing.vatId': 'VAT ID',
  'einvoicing.taxNumber': 'Tax number',
  'einvoicing.orderRef': 'Order reference',
  'einvoicing.buyerRef': 'Buyer reference (routing ID)',
  'einvoicing.linePos': 'Pos.',
  'einvoicing.lineName': 'Description',
  'einvoicing.lineQty': 'Quantity',
  'einvoicing.linePrice': 'Unit price',
  'einvoicing.lineVat': 'VAT',
  'einvoicing.lineTotal': 'Net',
  'einvoicing.totalNet': 'Total net',
  'einvoicing.totalVat': 'VAT amount',
  'einvoicing.totalPayable': 'Amount payable',
  'einvoicing.files': 'Files (original = legal artifact)',
  'einvoicing.fileKind.original': 'Original',
  'einvoicing.fileKind.generated': 'Generated',
  'einvoicing.fileKind.validation-report': 'Validation report',
  'einvoicing.fileKind.attachment': 'Attachment',
  'einvoicing.retentionUntil': 'Retain until',
  'einvoicing.pdfView': 'PDF view',
  'einvoicing.pdfShow': 'Show',
  'einvoicing.pdfHide': 'Hide',
  'einvoicing.pdfViewNote': 'Visual copy — the machine-readable XML is the legally authoritative document. The generated PDF envelope is not yet PDF/A-3 certified.',
  'einvoicing.actions': 'Actions',
  'einvoicing.approve': 'Approve',
  'einvoicing.reject': 'Reject',
  'einvoicing.commentPlaceholder': 'Comment (required for rejection) …',
  'einvoicing.rejectNeedsComment': 'Rejection requires a comment.',
  'einvoicing.approvedMsg': 'Invoice approved',
  'einvoicing.rejectedMsg': 'Invoice rejected',
  'einvoicing.postToSap': 'Post to SAP (MM-LIV)',
  'einvoicing.postedMsg': 'Posted to SAP',
  'einvoicing.sapDocNo': 'SAP document no.',
  'einvoicing.generate': 'Generate',
  'einvoicing.generatedMsg': 'File generated and archived',
  'einvoicing.markSent': 'Mark as sent',
  'einvoicing.sentMsg': 'Marked as sent',
  'einvoicing.validation': 'Validation',
  'einvoicing.validationOk': 'Core validation passed',
  'einvoicing.validationCoreNote': 'portal core rules; official Schematron check follows via sidecar',
  'einvoicing.matching': 'PR matching',
  'einvoicing.rematch': 'Re-run matching',
  'einvoicing.timeline': 'History',

  // Events
  'einvoicing.event.received': 'Invoice received',
  'einvoicing.event.validation_passed': 'Validation passed',
  'einvoicing.event.validation_failed': 'Validation failed',
  'einvoicing.event.matched': 'PR matching executed',
  'einvoicing.event.approved': 'Approved',
  'einvoicing.event.rejected': 'Rejected',
  'einvoicing.event.posted_to_sap': 'Posted to SAP',
  'einvoicing.event.sap_post_failed': 'SAP posting failed',
  'einvoicing.event.draft_created': 'Draft created',
  'einvoicing.event.generated': 'File generated',
  'einvoicing.event.sent': 'Sent',

  // Outbound
  'einvoicing.sapBillingDocs': 'SAP billing documents (adapter)',
  'einvoicing.sapBillingDocsHint': "Source: SAP adapter seam (mock today, Konstantin's real adapter later). Pick a document → portal draft → generate format.",
  'einvoicing.createDraft': 'Create draft',
  'einvoicing.draftCreatedMsg': 'Outbound draft created',

  // Countries & formats
  'einvoicing.coverageTitle': 'Regime coverage (8 countries)',
  'einvoicing.coverageHint': 'Verified = legal basis confirmed by adversarially verified research (as of 07/2026). Unverified regimes: no compliance commitments.',
  'einvoicing.covCountry': 'Country',
  'einvoicing.covModel': 'Model',
  'einvoicing.covFormats': 'Formats',
  'einvoicing.covChannels': 'Channels',
  'einvoicing.covSigning': 'Signing',
  'einvoicing.covArchive': 'Retention',
  'einvoicing.covStatus': 'Legal status',
  'einvoicing.covMandates': 'Obligations & dates',
  'einvoicing.years': 'years',
  'einvoicing.regimeVerified': 'verified',
  'einvoicing.regimeUnverified': 'UNVERIFIED',
  'einvoicing.signing.none': 'none (internal control procedure)',
  'einvoicing.signing.session': 'session auth (certificate)',
  'einvoicing.signing.per-invoice-b2g': 'B2G: qualified signature per file',
  'einvoicing.signing.platform': 'platform (PA) carries compliance',
  'einvoicing.signing.verifactu-records': 'hash chain + QR (Verifactu)',
  'einvoicing.signing.unknown': 'unclear',

  // Plant (Werk)
  'einvoicing.plant': 'Plant',
  'einvoicing.allPlants': 'All plants',
  'einvoicing.colPlant': 'Plant',
  'einvoicing.plantUnassigned': '— unassigned —',
  'einvoicing.plantSetMsg': 'Plant assigned',
  'einvoicing.event.plant_set': 'Plant assigned',

  // Ausgangsrechnung von Hand + Einstellungen
  'einvoicing.manual.create': 'Enter invoice',
  'einvoicing.manual.title': 'Enter outgoing invoice',
  'einvoicing.manual.buyer': 'Buyer',
  'einvoicing.manual.buyerName': 'Name / company',
  'einvoicing.manual.vatId': 'VAT ID',
  'einvoicing.manual.taxNumber': 'Tax number',
  'einvoicing.manual.street': 'Street and number',
  'einvoicing.manual.postCode': 'Postcode',
  'einvoicing.manual.city': 'City',
  'einvoicing.manual.country': 'Country (e.g. DE)',
  'einvoicing.manual.eAddress': 'E-invoice address (email)',
  'einvoicing.manual.leitwegId': 'Leitweg ID or your reference at the customer',
  'einvoicing.manual.paymentTerms': 'Payment terms',
  'einvoicing.manual.rate0': '0 % – zero rate (§12(3) UStG)',
  'einvoicing.manual.vatHint': 'Tax-exempt supplies and reverse charge are not supported yet.',
  'einvoicing.manual.dueOrTermsHint': 'Enter a due date or payment terms.',
  'einvoicing.manual.dates': 'Invoice data',
  'einvoicing.manual.invoiceNumber': 'Invoice number',
  'einvoicing.manual.invoiceNumberHint': 'empty = next number from the number range',
  'einvoicing.manual.issueDate': 'Invoice date',
  'einvoicing.manual.deliveryDate': 'Delivery date',
  'einvoicing.manual.dueDate': 'Due date',
  'einvoicing.manual.orderReference': 'Buyer order number',
  'einvoicing.manual.currency': 'Currency',
  'einvoicing.manual.lines': 'Lines',
  'einvoicing.manual.lineName': 'Description',
  'einvoicing.manual.quantity': 'Quantity',
  'einvoicing.manual.unit': 'Unit',
  'einvoicing.manual.netPrice': 'Net unit price',
  'einvoicing.manual.vatRate': 'VAT',
  'einvoicing.manual.lineNet': 'Net',
  'einvoicing.manual.addLine': 'Add line',
  'einvoicing.manual.removeLine': 'Remove line',
  'einvoicing.manual.totalNet': 'Total net',
  'einvoicing.manual.totalTax': 'VAT',
  'einvoicing.manual.totalGross': 'Total amount',
  'einvoicing.manual.save': 'Create draft',
  'einvoicing.manual.noSeller': 'Seller data missing – an admin must enter it under "Settings" first.',
  'einvoicing.manual.unit.C62': 'Piece',
  'einvoicing.manual.unit.HUR': 'Hour',
  'einvoicing.manual.unit.DAY': 'Day',
  'einvoicing.manual.unit.KGM': 'kg',
  'einvoicing.manual.unit.MTR': 'Metre',
  'einvoicing.manual.unit.LS': 'Lump sum',
  'einvoicing.settings.button': 'Settings',
  'einvoicing.settings.title': 'E-invoicing settings',
  'einvoicing.settings.seller': 'Seller (own company)',
  'einvoicing.settings.sellerHint': 'Printed on every manually entered outgoing invoice. VAT ID or tax number, e-invoice address, contact (name, phone, email) and IBAN are required (XRechnung).',
  'einvoicing.settings.contact': 'Contact',
  'einvoicing.settings.contactName': 'Name',
  'einvoicing.settings.phone': 'Phone',
  'einvoicing.settings.email': 'Email',
  'einvoicing.settings.bank': 'Bank account',
  'einvoicing.settings.iban': 'IBAN',
  'einvoicing.settings.bic': 'BIC',
  'einvoicing.settings.numberRange': 'Number range',
  'einvoicing.settings.prefix': 'Prefix',
  'einvoicing.settings.nextNumber': 'Next number',
  'einvoicing.settings.saved': 'Settings saved',
};

export default einvoicing;
